import classnames from 'classnames'
import { css } from 'emotion'
import { Brand, LifeInsuranceStep, Product, QueryParamKeys } from '@evenfinancial/even-ts-static'
import * as React from 'react'
import { connect } from 'react-redux'

import { stepSelected } from 'embed/actions'
import { MultiProductDispatch } from 'embed/constants'
import { MultiProductState } from 'embed/reducers'

import { AdvertiserDisclosureContent } from 'embed/components/AdvertiserDisclosure/'
import DepositsDisclosure from 'embed/components/DepositsDisclosure'
import { LifeInsuranceAdvertiserDisclosure, LifeInsuranceDisclosure } from 'embed/components/LifeInsuranceDisclosure'
import LoanDisclosure from 'embed/components/LoanDisclosure'
import Modal from 'embed/components/Modal'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { TrustpilotWidget } from 'embed/components/TrustPilot'
import {
  brandSelector,
  configPartnerDisclaimerSelector,
  configStateSelector,
  isDotDashSelector,
  isFionaBrandedSelector,
} from 'embed/selectors/config'
import Parent from 'embed/services/Parent'

import {
  isStepByStepSelector,
  uiSelectedProductSelector,
  uiShouldHideSharedFooterSelector,
  uiShouldshowTrustPilotSelector,
} from 'embed/selectors/ui'
import { PlainCreditDisclosure } from 'embed/components/Credit/CreditDisclosure'

const styles = require('./styles')

export interface StoreProps {
  brand: Brand
  hideFooter: boolean
  isDotDash: boolean
  isFionaBranded: boolean
  isStepByStep: boolean
  partnerDisclaimer?: string
  selectedProduct: Product
  showTrustpilotWidget: boolean
}

interface DispatchProps {
  dispatchLifeInsuranceStepSelectedRequestACall: () => void
}

type Props = StoreProps & DispatchProps

const Footer: React.SFC<Props> = ({
  dispatchLifeInsuranceStepSelectedRequestACall,
  brand,
  hideFooter,
  isDotDash,
  isFionaBranded,
  isStepByStep,
  partnerDisclaimer,
  selectedProduct,
  showTrustpilotWidget,
}) => {
  const [modalVisible, setModalVisible] = React.useState(false)
  const toggleModalVisible = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    Parent.scrollToFrame()
    setModalVisible(!modalVisible)
  }

  let productDisclosure
  let productAdvertiserDisclosure = <AdvertiserDisclosureContent />
  switch (selectedProduct) {
    case Product.Deposits:
      productDisclosure = <DepositsDisclosure />
      break
    case Product.LifeInsurance:
      productAdvertiserDisclosure = LifeInsuranceAdvertiserDisclosure
      productDisclosure = <LifeInsuranceDisclosure />
      break
    case Product.Loan:
      productDisclosure = <LoanDisclosure />
      break
    case Product.CreditCard:
      productDisclosure = <PlainCreditDisclosure />
      break
    default:
  }

  const isLifeInsuranceProduct = selectedProduct === Product.LifeInsurance
  const isLoanProduct = selectedProduct === Product.Loan

  const disclosures = (
    <React.Fragment>
      {productAdvertiserDisclosure}
      {productDisclosure}
    </React.Fragment>
  )

  const onLifeInsuranceSupportClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    dispatchLifeInsuranceStepSelectedRequestACall()
  }

  const footerLinksLifeInsurance = (
    <>
      <a href="https://www.leaplife.com/terms" target="_blank">
        Terms
      </a>{' '}
      <a href="https://www.leaplife.com/privacy" target="_blank">
        Privacy
      </a>{' '}
    </>
  )

  const footerLinksFiona = (
    <>
      <a href="https://fiona.com/terms" target="_blank">
        Terms
      </a>{' '}
      <a href="https://fiona.com/privacy" target="_blank">
        Privacy
      </a>{' '}
      <a href="https://fiona.com/contact" target="_blank">
        Support
      </a>{' '}
    </>
  )

  const footerLinksEven = (
    <>
      <a href="https://evenfinancial.com/terms-of-service/" target="_blank">
        Terms
      </a>{' '}
      <a href="https://evenfinancial.com/privacy-policy/" target="_blank">
        Privacy
      </a>{' '}
      <a href="https://evenfinancial.com/contact/" target="_blank">
        Support
      </a>{' '}
    </>
  )

  let footerLinks = footerLinksEven
  if (isLifeInsuranceProduct) {
    footerLinks = footerLinksLifeInsurance
  } else if (isFionaBranded) {
    footerLinks = footerLinksFiona
  }
  return (
    <>
      {!hideFooter && (
        <ThemeConsumer>
          {({ colorTextPrimary, colorTextSecondary }) => (
            <div
              className={classnames(
                styles.footer,
                css(`
                  color: ${colorTextSecondary};

                  a { color: ${colorTextSecondary}; }
                  a:hover { color: ${colorTextPrimary}; }
                `),
                {
                  [css`
                    padding: 0 20px;
                  `]: isDotDash,
                },
              )}
            >
              <>
                {partnerDisclaimer && (
                  <div className={styles.partnerDisclaimer}>
                    <p>{partnerDisclaimer}</p>
                  </div>
                )}
                <div
                  data-testid="footer"
                  className={classnames(styles.footerContainer, isDotDash && isStepByStep && styles.stepByStep)}
                >
                  <div className={styles.left}>
                    {footerLinks}
                    <a href="#" onClick={toggleModalVisible}>
                      Disclosures
                    </a>{' '}
                    {isLoanProduct && (
                      <>
                        <a href="https://nmlsconsumeraccess.org/" target="_blank">
                          NMLS# 1475872
                        </a>{' '}
                      </>
                    )}
                    {!isLifeInsuranceProduct && (
                      <img
                        alt="Equal Housing Opportunity"
                        className={styles.housingLogo}
                        src="https://images.evenfinancial.com/icons/eho-black.png"
                      />
                    )}
                    {modalVisible && <Modal onDismiss={toggleModalVisible}>{disclosures}</Modal>}
                  </div>
                  <div className={styles.right}>
                    {isFionaBranded && !isLifeInsuranceProduct && (
                      <span className={styles.inPartnershipWith}>
                        in partnership with{' '}
                        <a href="https://fiona.com" target="_blank">
                          Fiona
                        </a>
                      </span>
                    )}
                    {isLifeInsuranceProduct && (
                      <span className={styles.inPartnershipWith}>
                        in partnership with{' '}
                        <a href="https://www.leaplife.com" target="_blank">
                          LeapLife
                        </a>
                      </span>
                    )}
                    <span className={styles.poweredByEven}>
                      powered by{' '}
                      <a href="https://engine.tech" target="_blank">
                        Engine
                      </a>
                    </span>
                  </div>
                </div>
                <div className={classnames(styles.containerBottom, !showTrustpilotWidget && styles.noContent)}>
                  {showTrustpilotWidget && <TrustpilotWidget widget={'microStar'} brand={brand} />}
                </div>
              </>
            </div>
          )}
        </ThemeConsumer>
      )}
    </>
  )
}

const mapStateToProps = (state: MultiProductState) => ({
  brand: brandSelector(state),
  hideFooter: configStateSelector(state)[QueryParamKeys.HideFooter] || uiShouldHideSharedFooterSelector(state),
  isDotDash: isDotDashSelector(state),
  isFionaBranded: isFionaBrandedSelector(state),
  isStepByStep: isStepByStepSelector(state),
  partnerDisclaimer: configPartnerDisclaimerSelector(state),
  selectedProduct: uiSelectedProductSelector(state),
  showTrustpilotWidget: uiShouldshowTrustPilotSelector(state),
})

const mapDispatchToProps = (dispatch: MultiProductDispatch) => ({
  dispatchLifeInsuranceStepSelectedRequestACall: () => {
    dispatch(stepSelected(Product.LifeInsurance, LifeInsuranceStep.RequestACall))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(Footer)
